import { render } from "./AdminActionsView.vue?vue&type=template&id=87b08fe8"
import script from "./AdminActionsView.vue?vue&type=script&lang=js"
export * from "./AdminActionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__